export const GET_EX_CO_TENANT_DETAILS = 'express-checkout-tenant-details';
export const GET_ORDER_SUMMARY = 'order-summary';
export const GET_BUY_IT_AGAIN = 'buy-it-again';
export const GET_ORDER_FEEDBACK_GROUPS = 'order-feedback-groups';
export const GET_ORDER_FULFILLMENT_HISTORY = 'order-fulfillment-history';
